export default __webpack_public_path__ + "static/media/expand_charcoal.06a25d0f.svg";